const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const doorCanvassPasses = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "CLEAR_DOOR_CANVASS_PASS_CACHE":
      return { ...state, data: [] };

    case "SET_DOOR_CANVASS_PASSES":
      console.log("setting in retu");
      return { ...state, data: action.data };

    case "UPDATE_DOOR_CANVASS_PASS":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case "REMOVE_DOOR_CANVASS_PASS":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case "INSERT_DOOR_CANVASS_PASS":
      return { ...state, data: [...state.data, action.data] };

    case "SET_CAMPAIGN_DOOR_CANVASS_PASSES_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_CAMPAIGN_DOOR_CANVASS_PASSES_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default doorCanvassPasses;
